import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgbPopoverModule, NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { EdpSelectListComponent } from "./edp-select-list.component";

@NgModule({
    declarations: [EdpSelectListComponent],
    imports: [CommonModule, TranslateModule, NgbDropdownModule, NgbPopoverModule],
    exports: [EdpSelectListComponent],
})
export class EdpSelectListModule {}
